export default "__VITE_ASSET__BQxoCk$9__"